var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.count),expression:"count"}]},[_vm._v("\n    "+_vm._s(_vm.$tc('text', _vm.getText, { count: _vm.count, total: _vm.total }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }